import { useCallback } from 'react';
import { getMyCredits } from '@/app/apis';
import { useStore } from '@/app/providers/store';
import { useFetch } from './use-fetch';

export const useCredits = (options?: { refreshOnWindowFocus?: boolean; focusTimespan?: number }) => {
  const { creditsInfo, updateCreditsInfo } = useStore((state) => ({
    creditsInfo: state.creditsInfo,
    updateCreditsInfo: state.updateCreditsInfo,
  }));
  const { run, runAsync } = useFetch(getMyCredits, {
    manual: true,
    ...(options ?? {}),
    onSuccess: ({ data }) => {
      if (!data) return;
      // 所有字段都没有变化，不更新
      if (
        creditsInfo &&
        data.credits === creditsInfo.total &&
        data.credits_free === creditsInfo.free &&
        data.credits_subscribed === creditsInfo.subscribed &&
        data.credits_purchased === creditsInfo.purchased
      ) {
        return;
      }
      updateCreditsInfo({
        total: data.credits,
        free: data.credits_free ?? 0,
        subscribed: data.credits_subscribed ?? 0,
        purchased: data.credits_purchased ?? 0,
        credit_sub_expires_at: data.credit_sub_expires_at || null,
      });
    },
  });

  const updateCredits = useCallback(() => {
    run();
  }, [run]);

  const updateCreditsAsync = useCallback(async () => {
    return runAsync();
  }, [runAsync]);

  return {
    updateCredits,
    updateCreditsAsync,
  };
};
